module.exports = __webpack_public_path__ + "media/images/img-cindy-burdette-71cea94f7bafbf31bd05e8a6ba8e0e4b.jpg";